// extracted by mini-css-extract-plugin
export default {"badge":"NotificationsDropdown_badge__wQIHq"};